import { graphql } from "~/gql";

export const DELETE_DISCOUNT = graphql(/* GraphQL */ `
  mutation deleteDiscount($discountId: Float!) {
    deleteDiscount(discountId: $discountId) {
      discountId
    }
  }
`);
